<template>
  <div>
    <div class="header">
      <div class="tops">
        <div class="header-width">
          <div class="pull-left">服务热线：400-801-0928</div>
          <div class="pull-right">
          </div>
          <div class="clearfix"></div>
        </div>
      </div>

      <div class="clearfix"></div>

      <div class="logo">
        <div class="header-width">
          <div class="row">
            <div class="col-md-8 md8 login-top">
              <a>
                <img :src="mainLogo" />
              </a>
              <div class="login-top-str">{{ headTitle }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="topul">
        <div class="header-width">
          <ul>
            <!--<li class="linkli " v-for="(item,index) in linklis" :class="{active:index===ins}" @click="active(index)" :key="index"><router-link :to="item.url">{{item.name}}</router-link></li>-->
            <li class="linkli">
              <router-link to="/preRegistration/index" active-class="active" exact>预报名</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <a-form
          :model="formState"
          name="basic"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 8 }"
          autocomplete="off"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            label="姓名"
            name="name"
            :rules="[{ required: true, message: '请输入姓名!' }]"
        >
          <a-input v-model:value="formState.name" />
        </a-form-item>
        <a-form-item
            label="身份证号"
            name="idNo"
            :rules="[{ required: true, message: '请输入身份证号!' }]"
        >
          <a-input v-model:value="formState.idNo" />
        </a-form-item>
        <a-form-item
            label="联系方式"
            name="phone"
            :rules="[{ required: true, message: '请输入联系方式!' }]"
        >
          <a-input v-model:value="formState.phone" />
        </a-form-item>
        <a-form-item
            label="年级"
            name="gradeName"
            :rules="[{ required: true, message: '请输入年级!' }]"
        >
          <a-input v-model:value="formState.gradeName" />
        </a-form-item>
        <a-form-item label="专业层次">
          <a-select v-model:value="formState.learnLevel" @change="learnLeveChange">
            <a-select-option v-for="item in learnLevelOption" :key="item" :value="item" >{{ item }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="专业">
          <a-select v-model:value="formState.professionName" @change="proChange">
            <a-select-option v-for="(item,index) in proList" :key="item.proName" :value="item.proName">{{ item.proName }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="教学点">
          <a-select v-model:value="formState.statName" @change="siteChange">
            <a-select-option v-for="(item,index) in siteList" :key="item.departName" :value="item.departName">{{ item.departName }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 16, offset: 8 }">
          <a-button type="primary" @click="onSubmit" style="background: #2caf7a;border: none;color:#fff;">提交</a-button>
          <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
        </a-form-item>
      </a-form>
    </div>
    <Foot class="foot"></Foot>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Foot from "@/common/components/Foot";

import ForgetPassword from '@/pages/PersonalCenters/components/ForgetPassword'
import {getProfessionList} from '@/api/api'
export default {
  name: 'PreRegistration',
  components: { ForgetPassword,Foot },
  data: function () {
    return {
      eduCode: null,
      formState: {},
      learnLevelOption: ['专升本','高起本','高起专'],
      proList: null, // 专业列表
      siteList: null,
      mainLogo: '',
      loginTopStr: '',
      headTitle: '成人高等继续教育学习平台'
    }
  },
  computed: {

  },
  created() {
    const id = this.$route.query.id
    this.eduCode = id
    if (id) {
      this.axios.get(`/sys/login/logo?id=${id}`).then((res) => {
        if (res.success) {
          this.mainLogo = res.result.mainLogo || `/static/images/loginlogo.png`;
        }
      });
      this.axios.get(`/common/site/list?eduCode=${id}`).then((res) => {
        if (res.success) {
          this.siteList = res.result
        }
      });
    }
  },
  mounted() {

  },
  methods: {
    onFinish() {

    },
    onFinishFailed() {

    },
    onSubmit() {

      this.formState.eduCode = this.eduCode
      console.log(this.formState)
      this.axios.post('/preRegistration/add', this.formState).then((res) => {
        console.log(res)
        if (res.success) {
          this.$message.success('提交成功')
        }
      });
    },
    resetForm() {
      this.formState = {}
    },
    learnLeveChange(val) {
      this.axios.get('/common/profession/list?eduCode=' + this.eduCode + "&learnLevel=" + val).then((res) => {
        console.log(res)
        this.proList = res.result
      })
    },
    siteChange(val) {
      this.siteList.forEach((item) => {
        if(item.departName == val){
          this.formState.statCode = item.orgCode
        }
      })

    },
    proChange(val) {
      this.proList.forEach((item) => {
        if(item.proName == val){
          this.formState.professionId = item.id
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
[v-cloak] {
  display: none;
}
.header {
  background: $bgColor1;
  height: 258px;
  position: relative;

  .righinfo {
    color: #fff;
  }

  .exit {
    background: $bgColor;
    padding: 2px 12px;
    color: #fff;
    font-size: 14px;
    border-radius: 23px;
  }

  .topul {
    height: 50px;
    line-height: 50px;
    background: $bgColor;
    width: $pageWidth;
    margin: 0 auto;
    position: absolute;
    bottom: 0; /* 放到最下面 */
    left: 50%; /* 水平居中 */
    transform: translateX(-50%); /* 水平居中 */
  }

  .logo {
    margin-top: 30px;
  }

  .header-width {
    width: $pageWidth;
    margin: 0 auto;
  }
  .login-top {
    display: flex;
    align-items: center;
    .login-top-str {
      margin-left: 20px;
      color: #FFFFFF;
      font-size: 30px;
    }
  }
}

.header-left {
  float: left;
  margin-top: 10px;
}

.header-right {
  padding: 0 0.1rem;
  margin-top: 8px;
  float: right;
  text-align: center;
  color: #fff;

  p {
    line-height: 30px;
  }
}

.linkli {
  float: left;
  padding: 0 20px;
  cursor: pointer;
  a {
    color: #fff;
  }
}

.active {
  border-bottom: 2px solid #fff;
  padding-bottom: 10px;
}

.tops {
  height: 40px;
  line-height: 40px;
  background: #333333;
  color: #fff;
}

.rightinfo {
  color: #fff;

  a {
    color: #fff;
  }
}

.download {
  color: #fff;

  .col-md-4 {
    text-align: center;
    margin-right: 0;
    margin-left: 0;

    .texts {
      margin-top: 10px;
    }
  }
}

.logo {
  .md8 {
    -webkit-box-flex: 0;
    flex: 0 0 75%;
    max-width: 75%;
  }

  .md4 {
    -webkit-box-flex: 0;
    flex: 0 0 25%;
    max-width: 25%;
  }
}
.content {
  height: 500px;
  line-height: 50px;
  width: $pageWidth;
  margin: 0 auto;
  position: absolute;
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
}
.foot {
  position: fixed; /* 固定在浏览器视口 */
  bottom: 0; /* 放在最下面 */
  left: 0; /* 从左到右占满宽度 */
  width: 100%; /* 宽度占满整个视口 */
  z-index: 100; /* 确保 Foot 在最上层 */
}
</style>



// WEBPACK FOOTER //
// src/pages/preRegistration/index.vue